/* istanbul ignore file */
import React from 'react'
import PropTypes from 'prop-types'
import StepPreBooking from '../../components/StepPreBooking'
import Step1 from '../../components/Step1'
import Step2 from '../../components/Step2'
import Step4 from '../../components/Step4'
import Step3 from '../../components/Step3'
import { STEP_1, STEP_2, STEP_3, STEP_4, STEP_PRE_BOOKING } from '../../constants'

const CurrentStep = ({ step, lastStep, share, setOnCloseModal, goToNextStep, contactRentalCar, goToStep, offeredParkingPass, navigate, goToPrevStep, ...restProps }) => {
    if (step === STEP_1) {
        return <Step1 navigate={navigate} />
    }
    if (step === STEP_2) {
        return <Step2 onNext={goToNextStep} setOnCloseModal={setOnCloseModal} goToStep={goToStep} offeredParkingPass={offeredParkingPass} {...restProps} />
    }
    if (step === STEP_3) {
        return <Step3 lastStep={lastStep} onNext={goToNextStep} onBack={goToPrevStep} setOnCloseModal={setOnCloseModal} />
    }
    if (step === STEP_4) {
        return <Step4 share={share} onNext={contactRentalCar} setOnCloseModal={setOnCloseModal} onBack={() => goToStep(STEP_2)} goToStep={goToStep} navigate={navigate} {...restProps} />
    }
    if (step === STEP_PRE_BOOKING) {
        return <StepPreBooking navigate={navigate} onContinue={() => goToStep(STEP_4)} />
    }
    return null
}

CurrentStep.propTypes = {
    step: PropTypes.number,
    goToNextStep: PropTypes.func,
    contactRentalCar: PropTypes.func,
    goToStep: PropTypes.func,
    share: PropTypes.bool,
    offeredParkingPass: PropTypes.object,
    navigate: PropTypes.func.isRequired,
    setOnCloseModal: PropTypes.func.isRequired,
    lastStep: PropTypes.number,
    goToPrevStep: PropTypes.func,
}

export default CurrentStep
